/**
 * Message mode/origin constants
 * Defines the different modes for viewing messages (inbox, outbox, generic)
 */
export const MESSAGE_MODE = {
  INBOX: 'inbox',
  OUTBOX: 'outbox',
  GENERIC: 'generic',
} as const;

export type MessageMode = typeof MESSAGE_MODE[keyof typeof MESSAGE_MODE];
